import { render, staticRenderFns } from "./publicapidoc.vue?vue&type=template&id=11027cab&scoped=true"
import script from "./publicapidoc.vue?vue&type=script&lang=ts"
export * from "./publicapidoc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11027cab",
  null
  
)

export default component.exports